import AbstractScene from './AbstractScene.js';
import { TextContents } from '../consts/TextContents.js';
import { Colors } from '../consts/Colors.js';
import ButtonRounded from '../prefabs/buttons/ButtonRounded.js';
import RoundedContainer from '../prefabs/RoundedContainer.js';

import TraductionManager from '../prefabs/TraductionManager.js';

export default class Menu extends AbstractScene {
    constructor() {
        super({
            key: 'Menu',
        });
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        this.traductionManager = new TraductionManager();
    }

    create() {
        this.background = this.add.image(0, 0, 'backMenu').setOrigin(0);
        this.background.setDisplaySize(this.width, this.height);
        this.backShadow = this.add
            .rectangle(0, 0, this.width, this.height, Colors.Elmt.DeepBlue, 0.8)
            .setOrigin(0);
        this.introBackground = this.add
            .rectangle(
                this.width / 2,
                this.height / 2,
                850 * this.game.data.scaleX,
                400 * this.game.data.scaleY,
                Colors.Elmt.White
            )
            .setOrigin(0.5, 0.5);
        let title = {
            text: this.traductionManager.getText(TextContents.textTitle.text),
            config: TextContents.textTitle.config,
        };
        this.title = this.createTextElement(
            this.game.data.langue === 'ara' ? this.width / 2 + 300 : this.width / 2,
            this.height / 2,
            title
        );
        // this.intro = this.createTextElement(this.width / 2, 610, TextContents.textIntro);
        /*  this.introBtn = this.add
      .image(960 * 0.44, 680 * 0.36, "btnFirst")
      .setOrigin(0.5, 0.5); */

        this.introBtn = this.add
            .existing(
                new ButtonRounded(
                    this,
                    this.width / 2,
                    this.height / 2 + 190 * this.game.data.scaleY,
                    200 * 2 * this.game.data.scaleX,
                    96 * 1.5 * this.game.data.scaleY,
                    this.traductionManager.getText('btnStart'),
                    Colors.Text.White,
                    Colors.Elmt.MiddleBlue,
                    false,
                    Colors.Text.Blue,
                    null
                )
            )
            .setVisible(true)
            .setDepth(1000);

        this.introBtn.setInteractive({ useHandCursor: true });

        this.introBtn.on('pointerup', (e) => {
            // this.scene.start("Game");
            this.introBackground.destroy();
            this.title.destroy();
            // this.intro.destroy()
            this.introBtn.destroy();

            const consigneText = this.traductionManager.getText('consigneIntro');
            const tempText = this.add.text(0, 0, consigneText);
            const textWidth = tempText.width;
            tempText.destroy();

            this.consigneContainer = this.add.existing(
                new RoundedContainer(
                    this,
                    this.width / 2,
                    403 * this.game.data.scaleY - 50,
                    this.game.data.langue === 'ara'
                        ? 600 * this.game.data.scaleX
                        : 700 * this.game.data.scaleX,
                    220 * this.game.data.scaleY,
                    'icon_tortue',
                    this.traductionManager.getText('consigneIntro'),
                    Colors.Elmt.White
                )
            );

            this.btnTuto = this.add.existing(
                new ButtonRounded(
                    this,
                    this.width / 2,
                    581 * this.game.data.scaleY + 40,
                    380 * 1.2 * this.game.data.scaleX,
                    96 * 1.5 * this.game.data.scaleY,
                    this.traductionManager.getText('btnTuto'),
                    Colors.Text.DarkBlue,
                    Colors.Elmt.White,
                    false,
                    Colors.Text.Blue,
                    true,
                    this.game.data.langue === 'ara' ? 'arrow-left' : 'arrow-right',
                    null
                )
            );
            this.btnTuto.setInteractive({ useHandCursor: true });
            this.btnTuto.on('pointerover', (e) => {
                this.btnTuto.setScale(1.05);
            });
            this.btnTuto.on('pointerout', (e) => {
                this.btnTuto.setScale(1);
            });
            this.btnTuto.on('pointerup', (e) => {
                this.scene.start('GameTuto');
            });
            console.log('game data', this.game.data);
            console.log('langue menu', this.game.data.langue);
            this.btnSkip = this.add.existing(
                new ButtonRounded(
                    this,
                    this.width / 2,
                    581 * this.game.data.scaleY + 96 * this.game.data.scaleY + 100,
                    380 * 1.2 * this.game.data.scaleX,
                    96 * 1.5 * this.game.data.scaleY,
                    this.traductionManager.getText('btnSkip'),
                    Colors.Text.DarkBlue,
                    Colors.Elmt.White,
                    false,
                    Colors.Text.Blue,
                    true,
                    this.game.data.langue === 'ara' ? 'arrow-left' : 'arrow-right',
                    null
                )
            );

            this.btnSkip.setInteractive({ useHandCursor: true });
            this.btnSkip.on('pointerover', (e) => {
                this.btnSkip.setScale(1.05);
            });
            this.btnSkip.on('pointerout', (e) => {
                this.btnSkip.setScale(1);
            });
            this.btnSkip.on('pointerup', (e) => {
                this.game.data.tutoOn = false;
                this.scene.start('Game');
            });
        });
    }
}
